import { render, staticRenderFns } from "./accredited-cpd-provider-report.vue?vue&type=template&id=6d9b2a24"
import script from "./accredited-cpd-provider-report.vue?vue&type=script&lang=js"
export * from "./accredited-cpd-provider-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports